import Component from "@glimmer/component";
import { service } from "@ember/service";
import { task, Task } from "ember-concurrency";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { shape, instanceOf } from "prop-types";
import { tracked } from "@glimmer/tracking";
import { on } from "@ember/modifier";
import { not } from "ember-truth-helpers";
import { t } from "ember-intl";
import Header from "glesys-controlpanel/components/g-modal/header";
import Body from "glesys-controlpanel/components/g-modal/body";
import Footer from "glesys-controlpanel/components/g-modal/footer";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import GButton from "glesys-controlpanel/components/g-button";
import GInput from "glesys-controlpanel/components/g-input";
import Label from "glesys-controlpanel/components/label";
import TaskForm from "glesys-controlpanel/components/task-form";

@forbidExtraArgs
export default class ModalsDatabaseCreateDatabase extends Component {
  @service modal;

  @arg(
    shape({
      task: instanceOf(Task).isRequired,
    }).isRequired,
  )
  params;

  @tracked name = "";

  get canSubmit() {
    return this.name.trim().length > 0;
  }

  onChange = ({ name }) => (this.name = name);

  onSubmitTask = task(async () => {
    await this.params.task.perform(this.name.trim());
    this.modal.close();
  });

  <template>
    <Header>{{t "databases.details.databases.create.title"}}</Header>
    <Body>
      <p class="text-gray-500 pb-6">{{t "databases.details.databases.create.description"}}</p>
      <TaskForm id="create-database-form" @onChange={{this.onChange}} @task={{this.onSubmitTask}}>
        <Label for="create-database-name">{{t "databases.details.databases.create.name-label"}}</Label>
        <GInput
          id="create-database-name"
          data-test-modal-database-create-database-name
          name="name"
          value={{this.name}}
          placeholder={{t "databases.details.databases.create.name-placeholder"}}
        />
      </TaskForm>
    </Body>
    <Footer>
      <GButton class="mr-2" data-test-cancel-button @color="gray" {{on "click" (modalClose)}}>
        {{t "button.cancel"}}
      </GButton>
      <GButton
        data-test-modal-database-create-database-submit
        @type="submit"
        @color="blue"
        @loading={{this.onSubmitTask.isRunning}}
        @disabled={{not this.canSubmit}}
        form="create-database-form"
      >
        {{t "databases.details.databases.create.submit"}}
      </GButton>
    </Footer>
  </template>
}
